<template>
    <div class="col-md-3 col-sm-12 col-xs-12 col-lg-3 col-xl-3" 
        @drop="onDrop($event,status)"
        @dragover.prevent
        @dragcenter.prevent
    >
        <div class="bg-dark text-center pb-3 col-md-12 ps-2 pe-2 rounded">
            <div class="title mb-3 text-capitalized text-light" style="font-size:3vh">
                {{status}}
            </div>
            <div class="content" style="max-height:700px;overflow-y:scroll">
                <cards 
                    v-for="(data, id) in getTask(status)" 
                    :key="id" 
                    :datas="data"
                    @showModalEdit="showModalEdit(data)"
                    @showModalDelete="showModalDelete"
                    @showModalError="showModalError"
                    @start-drag="startDrag"
                    >
                </cards>
            </div>
            <!-- <div class="button pt-3"> -->

    <!-- Button trigger modal -->
            <button type="button" class="btn btn-secondary mt-3" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="showModalCreate">
                Add Task
            </button>
<!-- 
                <div class="btn btn-primary"> Add Task </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import cards from './cards.vue'
export default {
    components: {
        cards
    },
    name: "categories",
    props:["tasks","status"],
    data() {
        return {
        message: 'Hello world',
        category: ['backlog','todo','doing','completed']
        };
    },
    methods : {
        showModalCreate(){
            this.$emit('showModalCreate',status)
        },
        showModalEdit(data){
            this.$emit('showModalEdit',data)
        },
        showModalError(){
            this.$emit('showModalError')
        },
        showModalDelete(id){
            this.$emit('show-modal-delete',id)
        },
        getTask(data){
            const tasks = this.tasks.data
            try{
                let filteredTask = tasks.filter(element => element.category.toLowerCase() == data.toLowerCase())
                if (filteredTask.length > 0) {
                    // console.log(tasks,data)
                    return filteredTask
                }else{
                    return []
                }
            }
            catch(err) {
                // console.log(err,data)    
                return []
            }
        //     if (tasks.length > 0) {
        //         tasks.filter(element => element.category.toLowerCase() == data.toLowerCase())
        //         // console.log(tasks)
        //         return tasks
        //     }else{
        //     }
        //     console.log(tasks)
        //         console.log(data,'category')
        },
        startDrag(ev, item) {
            this.$emit('start-drag',ev, item)
            // this.$emit('start-drag',ev, item)
        },
        onDrop(ev, category) {
            // console.log(category)
            this.$emit('on-drop',ev,category)
            // const itemID = evt.dataTransfer.getData('itemID')
            // const item = this.items.find(item => item.id == itemID)
            // item.list = list
        }


    }
};
</script>

<style scoped>
div.content::-webkit-scrollbar {
    width: 2px; /* remove scrollbar space */
    background: transparent; /* optional: just make scrollbar invisible /
}
/ optional: show position indicator in red */
}
div.content::-webkit-scrollbar-thumb {
    background: #82d0fd;
}
</style>